import camera from "@/assets/screenshot.mp3";

const cameraFX = new Audio(camera);

export enum Sounds {
    Camera = 0,
}

export const playSound = (sound: Sounds) => {
    switch (sound) {
        case Sounds.Camera:
            cameraFX.play();
            break;
    }
};
